module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../images/chevron-left.52e9ba5b.svg";